import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	content: {
		marginBottom: theme.spacing(2)
	},
	skeletonContainer: {
		padding: `0 ${theme.spacing(2)}px`,
		paddingBottom: theme.spacing(1)
	}
}));
